module.exports = __webpack_public_path__ + "img/main-h5.cdef1dfe.png";